import { useQuery } from "@tanstack/react-query";
import { getReferralsHistory, getReferralsStatus } from "./services";

export const useReferralsStatusQuery = () =>
  useQuery({
    queryKey: ["referralsStatus"],
    queryFn: getReferralsStatus,
    staleTime: Infinity,
  });

export const useReferralsHistoryQuery = () =>
  useQuery({
    queryKey: ["referralsHistory"],
    queryFn: getReferralsHistory,
    staleTime: Infinity,
  });
